import Highcharts from 'highcharts';

export const baseGraphConfigs: Highcharts.Options = {
  plotOptions: {
    line: {
      states: {
        hover: {
          color: 'inherit'
        },
        select: {
          color: 'inherit'
        }
      }
    },
    column: {
      dataLabels: {
        enabled: true,
        format: '{y}%'
      }
    }
  },
  credits: {
    enabled: false
  },
  exporting: {
    enabled: false
  },
  chart: {
    height: 225
  },
  title: {
    text: ''
  },
  yAxis: {
    title: {
      text: ''
    }
  },
  xAxis: {
    labels: {
      enabled: false
    }
  },
  legend: {
    enabled: false
  }
};
